var React = require('react');

function Devices (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"63","height":"63","rx":"31.5","fill":"#FF6685","fillOpacity":"0.1","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"63","height":"63","rx":"31.5","stroke":"black","key":1}),React.createElement("path",{"d":"M29 43.5H22C20.343 43.5 19 42.157 19 40.5V21.5C19 19.843 20.343 18.5 22 18.5H36C37.657 18.5 39 19.843 39 21.5V25.5","stroke":"#FF6685","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"square","key":2}),React.createElement("path",{"d":"M42 29.5H36C34.3431 29.5 33 30.8431 33 32.5V43.5C33 45.1569 34.3431 46.5 36 46.5H42C43.6569 46.5 45 45.1569 45 43.5V32.5C45 30.8431 43.6569 29.5 42 29.5Z","stroke":"#FF6685","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"square","key":3})]);
}

Devices.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = Devices;

Devices.default = Devices;
